// Cadencia del sondeo de los imports asíncronos (mayor, ventas/costos): el
// POST responde 202 y la vista consulta el estado hasta S/E. Antes había un
// tope fijo de 100 intentos × 3 s (~5 min) que dejaba el readout apagado y sin
// refrescar cuando un import grande demoraba más (prod 2026-09-15). Ahora el
// sondeo NO se corta: acelera al principio, se relaja después y, pasado el
// tope de tiempo, sigue lento hasta que el worker termine.
export const POLL_FAST_MS = 3000;
export const POLL_RELAXED_MS = 10000;
export const POLL_IDLE_MS = 30000;
export const POLL_FAST_WINDOW_MS = 2 * 60 * 1000;
export const POLL_OVERDUE_MS = 45 * 60 * 1000;
// Errores seguidos al leer el estado antes de avisar (un 5xx aislado o un
// corte de red no debe apagar el readout: el import sigue en el worker).
export const POLL_MAX_CONSECUTIVE_FAILURES = 3;

// Milisegundos hasta la próxima lectura según lo que lleva el sondeo.
export function nextPollDelay(elapsedMs) {
	const elapsed = Math.max(Number(elapsedMs) || 0, 0);
	if (elapsed < POLL_FAST_WINDOW_MS) {
		return POLL_FAST_MS;
	}
	if (elapsed < POLL_OVERDUE_MS) {
		return POLL_RELAXED_MS;
	}
	return POLL_IDLE_MS;
}

// El import lleva más que el tope de tiempo: se avisa una vez y se sigue
// sondeando en modo lento.
export function isPollOverdue(elapsedMs) {
	return (Number(elapsedMs) || 0) >= POLL_OVERDUE_MS;
}
